import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CellComponent } from '@shared/components/cell-components/cell-component';
import { FieldDefinition } from '@shared/models/field-definition';

@Component({
    standalone: false,
    selector: 'particle-data-mapping-orbitax-tool-cell-viewer',
  templateUrl: './data-mapping-orbitax-tool-cell-viewer.component.html',
  styleUrls: ['./data-mapping-orbitax-tool-cell-viewer.component.scss']
})
export class DataMappingOrbitaxToolCellViewerComponent implements OnInit, AfterViewInit, CellComponent {
  fieldDefinition: FieldDefinition;
  item: any;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();

  constructor() {

  }

  ngOnInit() {

  }
  ngAfterViewInit (): void {

  }
  onClick() {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition});
  }
}
